import React, { Component } from "react";
import { Spin, Radio, Space, message, DatePicker, Checkbox } from "antd";
import Bridge from "../../utils/Bridge";
import dayjs from "dayjs";
import moment from "moment";

export default class AdditionalHealthInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      do_you_have_assistive_technology: "",
      have_you_been_diagnosed_with_hearing_loss: "",
      are_you_attended_speech_therapy_or_speech_pathologist: "",
      yes_currently_start_date: null,
      yes_in_past_start_date: null,
      yes_in_past_end_date: null,
      additional_health_info_apply_to_you_list: [],

      are_you_on_any_medication: "",
      if_yes_are_you_on_any_medication: "",
      have_you_been_in_a_clinical_trial: "",
      have_you_received_therapy: "",
      have_you_been_hospitalized: "",
      have_you_had_a_fall: "",
      how_many_years: "",
    };
  }
  componentDidMount() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    this.get_demographic_details();
  }
  get_demographic_details = () => {
    let params = "?eals_id=" + localStorage.getItem("ap_eals_id");
    Bridge.demographics.ecas_study
      .get(params)
      .then((response) => {
        this.setState({ loading: false });
        if (response.status == "1") {
          if (response.data.length > 0) {
            for (let item of response.data) {
              if (item.field == "Are you on any medication?") {
                this.setState({ are_you_on_any_medication: item.value });
              }
              if (item.field == "If yes, are you on any medication?") {
                this.setState({ if_yes_are_you_on_any_medication: item.value });
              }
              if (
                item.field == "Have you been or currently in a clinical trial?"
              ) {
                this.setState({
                  have_you_been_in_a_clinical_trial: item.value,
                });
              }
              if (
                item.field ==
                "Have you ever received therapy to improve your speech?"
              ) {
                this.setState({ have_you_received_therapy: item.value });
              }
              if (item.field == "Have you been diagnosed with hearing loss?") {
                this.setState({
                  have_you_been_diagnosed_with_hearing_loss: item.value,
                });
              }
              if (item.field == "Do any of the following apply to you?") {
                this.setState({
                  additional_health_info_apply_to_you_list: item.value
                    ? JSON.parse(item.value)
                    : "",
                });
              }

              if (
                item.field == "Have you been hospitalized in the past 3 months?"
              ) {
                this.setState({ have_you_been_hospitalized: item.value });
              }
              if (item.field == "Have you had a fall in the previous year?") {
                this.setState({ have_you_had_a_fall: item.value });
              }
              if (
                item.field ==
                "Have you had a fall in the previous year? - How many years"
              ) {
                this.setState({ how_many_years: item.value });
              }
            }
          }
        }
      })
      .catch((error) => {
        this.setState({ loading: false });
      });
  };
  getRandomInt = (min, max) => {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
  };
  save = () => {
    if (!this.state.are_you_on_any_medication) {
      message.warning("Please select Are you on any medication?");
      return;
    }
    if (this.state.are_you_on_any_medication == "Yes") {
      if (!this.state.if_yes_are_you_on_any_medication) {
        message.warning("Please enter If yes, are you on any medication?");
        return;
      }
    }
    if (!this.state.have_you_been_in_a_clinical_trial) {
      message.warning(
        "Please select Have you been or currently in a clinical trial?"
      );
      return;
    }
    if (!this.state.have_you_received_therapy) {
      message.warning(
        "Please select Have you ever received therapy to improve your speech?"
      );
      return;
    }
    if (!this.state.have_you_been_diagnosed_with_hearing_loss) {
      message.warning(
        "Please select Have you been diagnosed with hearing loss?"
      );
      return;
    }
    if (this.state.additional_health_info_apply_to_you_list.length == 0) {
      message.warning("Please select Do any of the following apply to you?");
      return;
    }
    if (!this.state.have_you_had_a_fall) {
      message.warning(
        "Please select Have you had a fall in the previous year? field option"
      );
      return;
    }
    if (this.state.have_you_had_a_fall == "Yes") {
      if (!this.state.how_many_years) {
        message.warning("Please enter How many years");
        return;
      }
    }

    let questions = [
      {
        parent_field: "Are you on any medication?",
        field: "Are you on any medication?",
        value: this.state.are_you_on_any_medication,
      },
      {
        parent_field: "Are you on any medication?",
        field: "If yes, are you on any medication?",
        value: this.state.if_yes_are_you_on_any_medication,
      },
      {
        parent_field: "Have you been or currently in a clinical trial?",
        field: "Have you been or currently in a clinical trial?",
        value: this.state.have_you_been_in_a_clinical_trial,
      },
      {
        parent_field: "Have you ever received therapy to improve your speech?",
        field: "Have you ever received therapy to improve your speech?",
        value: this.state.have_you_received_therapy,
      },
      {
        parent_field: "Have you been diagnosed with hearing loss?",
        field: "Have you been diagnosed with hearing loss?",
        value: this.state.have_you_been_diagnosed_with_hearing_loss
          ? this.state.have_you_been_diagnosed_with_hearing_loss
          : "No",
      },
      {
        parent_field: "Do any of the following apply to you?",
        field: "Do any of the following apply to you?",
        value: this.state.additional_health_info_apply_to_you_list
          ? JSON.stringify(this.state.additional_health_info_apply_to_you_list)
          : "",
      },

      {
        parent_field: "Have you been hospitalized in the past 3 months?",
        field: "Have you been hospitalized in the past 3 months?",
        value: this.state.have_you_been_hospitalized,
      },
      {
        parent_field: "Have you had a fall in the previous year?",
        field: "Have you had a fall in the previous year?",
        value: this.state.have_you_had_a_fall,
      },
      {
        parent_field:
          "Have you had a fall in the previous year? - How many years",
        field: "Have you had a fall in the previous year? - How many years",
        value: this.state.how_many_years,
      },
    ];
    let params = {
      eals_id: localStorage.getItem("ap_eals_id"),
      data: JSON.stringify(questions),
      step: "6",
      action_type: this.props.is_update == true ? "update" : "insert",
    };
    this.setState({ loading: true });
    Bridge.demographics.ecas_study
      .save(params)
      .then((response) => {
        this.setState({ loading: false });
        if (response.data.status == "1") {
          message.success(response.data.message);
          this.setState(
            {
              loading: false,
            },
            () => {
              if (this.props.is_update == true) {
                setTimeout(() => {
                  window.location.assign("/about-me");
                }, 3000);
              } else {
                setTimeout(() => {
                  window.location.assign("/dashboard");
                }, 3000);
              }
            }
          );
        } else {
          message.error(response.data.message);
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        message.warning("Please try again!!", error);
        this.setState({ loading: false });
      });
  };
  onChangeAdditionalHealthApplyOptions = (e) => {
    let value = e.target.value;
    let tempArr = this.state.additional_health_info_apply_to_you_list;
    if (tempArr.includes(value)) {
      let newArray = [];
      for (let item of tempArr) {
        if (item != value) {
          newArray.push(item);
        }
      }
      this.setState({ additional_health_info_apply_to_you_list: newArray });
    } else {
      tempArr.push(value);
      this.setState({ additional_health_info_apply_to_you_list: tempArr });
    }
  };
  render() {
    const disabledDate = (current) => {
      // Disable all dates after today
      return current && current > moment();
    };
    return (
      <div>
        <div className="header">
          <h3>ADDITIONAL HEALTH INFORMATION</h3>
          <div className="white-block"></div>
        </div>
        <Spin spinning={this.state.loading}>
          <div className="form-fields">
            <div className="form-group">
              <label className="mb-2 input-heading">
                Do you take any supplements / over the counter medications?
                &nbsp;<span className="text-danger">*</span>
              </label>
              <br />
              <Radio.Group
                onChange={(event) =>
                  this.setState({
                    are_you_on_any_medication: event.target.value,
                    if_yes_are_you_on_any_medication: "",
                  })
                }
                value={this.state.are_you_on_any_medication}
              >
                <Space direction="horizontal">
                  <Radio value={"Yes"}>Yes</Radio>
                  <Radio value={"No"}>No</Radio>
                </Space>
              </Radio.Group>
            </div>
            {this.state.are_you_on_any_medication == "Yes" && (
              <div className="form-group">
                <label className="mb-2 input-heading">Specify</label>
                <br />
                <input
                  type="text"
                  value={this.state.if_yes_are_you_on_any_medication}
                  onChange={(e) =>
                    this.setState({
                      if_yes_are_you_on_any_medication: e.target.value,
                    })
                  }
                  style={{ textTransform: "capitalize" }}
                  id="neurologist_physician_name"
                  placeholder="Specify.."
                  className="pr-2"
                />
              </div>
            )}
            <div className="form-group">
              <label className="mb-2 input-heading">
                Have you been or currently in a clinical trial?{" "}
                <span className="text-danger">*</span>
              </label>
              <br />
              <Radio.Group
                onChange={(event) =>
                  this.setState({
                    have_you_been_in_a_clinical_trial: event.target.value,
                  })
                }
                value={this.state.have_you_been_in_a_clinical_trial}
              >
                <Space direction="horizontal">
                  <Radio value={"Yes"}>Yes</Radio>
                  <Radio value={"No"}>No</Radio>
                </Space>
              </Radio.Group>
            </div>
            <div className="form-group">
              <label className="mb-2 input-heading">
                Have you ever received therapy to improve your speech?{" "}
                <span className="text-danger">*</span>
              </label>
              <br />
              <Radio.Group
                onChange={(event) =>
                  this.setState({
                    have_you_received_therapy: event.target.value,
                  })
                }
                value={this.state.have_you_received_therapy}
              >
                <Space direction="horizontal">
                  <Radio value={"Yes"}>Yes</Radio>
                  <Radio value={"No"}>No</Radio>
                </Space>
              </Radio.Group>
            </div>

            <div className="form-group">
              <label className="mb-2 input-heading">
                Have you been diagnosed with hearing loss?{" "}
                <span className="text-danger">*</span>
              </label>
              <br />
              <Radio.Group
                onChange={(event) =>
                  this.setState({
                    have_you_been_diagnosed_with_hearing_loss:
                      event.target.value,
                  })
                }
                value={this.state.have_you_been_diagnosed_with_hearing_loss}
              >
                <Space direction="horizontal">
                  <Radio value={"Yes"}>Yes</Radio>
                  <Radio value={"No"}>No</Radio>
                </Space>
              </Radio.Group>
            </div>
            <div className="form-group">
              <label className="input-heading">
                Do any of the following apply to you?{" "}
                <span className="text-danger">*</span>
              </label>
              <ul>
                <Checkbox.Group
                  onChange={(checkedValues) =>
                    this.setState({
                      additional_health_info_apply_to_you_list: checkedValues,
                    })
                  }
                  value={this.state.additional_health_info_apply_to_you_list}
                >
                  <Space direction="vertical">
                    <Checkbox
                      value={"Hearing impaired / wear a hearing aid"}
                      style={{ fontSize: "17px" }}
                    >
                      Hearing impaired / wear a hearing aid
                    </Checkbox>
                    <Checkbox
                      value={"Vision impaired / wear glasses"}
                      style={{ fontSize: "17px" }}
                    >
                      Vision impaired / wear glasses
                    </Checkbox>
                    <Checkbox
                      value={"Currently wearing a dental appliance or dentures"}
                      style={{ fontSize: "17px" }}
                    >
                      Currently wearing a dental appliance or dentures
                    </Checkbox>
                    <Checkbox
                      value={"None of the above"}
                      style={{ fontSize: "17px" }}
                    >
                      None of the above
                    </Checkbox>
                  </Space>
                </Checkbox.Group>
              </ul>
            </div>

            <div className="form-group">
              <label className="mb-2 input-heading">
                Have you been hospitalized in the past 3 months?
              </label>
              <br />
              <Radio.Group
                onChange={(event) =>
                  this.setState({
                    have_you_been_hospitalized: event.target.value,
                  })
                }
                value={this.state.have_you_been_hospitalized}
              >
                <Space direction="horizontal">
                  <Radio value={"Yes"}>Yes</Radio>
                  <Radio value={"No"}>No</Radio>
                </Space>
              </Radio.Group>
            </div>
            <div className="form-group">
              <label className="mb-2 input-heading">
                Have you had a fall in the previous year?{" "}
                <span className="text-danger">*</span>
              </label>
              <br />
              <Radio.Group
                onChange={(event) =>
                  this.setState({
                    have_you_had_a_fall: event.target.value,
                    how_many_years: "",
                  })
                }
                value={this.state.have_you_had_a_fall}
              >
                <Space direction="horizontal">
                  <Radio value={"Yes"}>Yes</Radio>
                  <Radio value={"No"}>No</Radio>
                </Space>
              </Radio.Group>
              {this.state.have_you_had_a_fall === "Yes" && (
                <div className="form-group mt-3">
                  <label className="mb-2 input-heading">How many falls?</label>
                  <br />
                  <input
                    type="number"
                    min={1}
                    value={this.state.how_many_years}
                    onChange={(e) =>
                      this.setState({ how_many_years: e.target.value })
                    }
                  />
                </div>
              )}
            </div>

            {this.props.is_update == true ? (
              <div className="d-flex mt-5">
                <button
                  className="submit-button ml-2"
                  style={{
                    marginLeft: 0,
                    padding: "9px 15px 10px 20px",
                  }}
                  onClick={() => this.save()}
                >
                  Save{" "}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                </button>
              </div>
            ) : (
              <div className="d-flex mt-5">
                <button
                  style={{
                    padding: "9px 28px 10px 21px",
                  }}
                  className="submit-button"
                  onClick={() => this.props.set_active_step(7)}
                >
                  <box-icon
                    name="chevron-left"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                  Previous
                </button>
                <button
                  className="submit-button ml-2"
                  style={{
                    marginLeft: 17,
                    padding: "9px 15px 10px 20px",
                  }}
                  onClick={() => this.save()}
                >
                  Save & Next{" "}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                </button>
              </div>
            )}
          </div>
        </Spin>
      </div>
    );
  }
}
